const configUpgradeParser = require('./lib/config-report-parser.js');

module.exports = configUpgradeParser;
